import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./AuthSlice";
import GlobalSettingSlice from "./GlobalSettingSlice";
import StatusSlice from "./StatusSlice";

export const allReducers = combineReducers({
        authSlice,
        GlobalSettingSlice,
        StatusSlice,
  })